<script>
import FavoriteTool from '../lib/favorite-tool.vue'
import VisitsTool from './visits-tool.vue'
import CategoryFacet from '../lib/category-facet.vue'
import ForMeTool from '../lib/for-me-tool.vue'
import CollapsibleSearch from '../lib/collapsible-search.vue'

export default {
    emits: ['search', 'delete-search'],
    components: {FavoriteTool, VisitsTool, CategoryFacet, ForMeTool, CollapsibleSearch},
    props: {
        favKey: {type: String, required: true},
        favMode: {type: Boolean, required: true},
        filter: {type: Object, required: true},
        visitsActive: {type: Boolean, default: false},
        numVisits: {type: Number, default: 0},
        eventShortName: {type: String, default: ''},
    },
    data() {
        return {
            search: this.filter.search,
        }
    },

    computed: {
        favActive() { return this.filter.favorites },
        forMeActive() { return !!this.filter.for_me },
    },

    methods: {
        rangeAtoZ() {
            let range = ['#']
            for (var i = 'A'.charCodeAt(0); i <= 'Z'.charCodeAt(0); i++) {
                range.push(String.fromCharCode(i));
            }
            return range
        },
        onSearchInput() {
            if (this.search === '') this.$emit('delete-search')
        },

        filterActive: function(letter) {
           return this.filter.company__name__gt == letter
        },
        toggleVisits() {
            this.$emit('toggle-visits', !this.visitsActive)
        }
    },
}
</script>

<template>
<div>
    <nav class="navbar bg-light px-3">
        <div class="d-flex flex-wrap align-items-center w-100 gap-2">
            <div class="d-flex align-items-center gap-1">
                <favorite-tool v-if="!favMode" :active="favActive" @click="$emit('toggle-favorites', !favActive)" />
                <visits-tool v-if="!favMode" :active="visitsActive" @click="toggleVisits()" />
                <for-me-tool :active="forMeActive" @click="$emit('toggle-for-me')" />
                <ul class="navbar-nav">
                  <category-facet :event-short-name="eventShortName" :value="filter.categories || []"
                   @change="$emit('categories', $event)" />
                </ul>
                <button class="btn btn-sm navbar-btn me-1 mb-1 c-tool-btn"
                 title="Liste exportieren" @click.prevent="$emit('export-list')">
                    <i class="fas fa-download"></i>
                    <span class="c-tool-btn-label">Export</span>
                </button>
            </div>
            <collapsible-search class="ms-auto" :value="filter.search || ''"
              @search="$emit('search', $event)" @delete-search="$emit('delete-search')" />
        </div>
    </nav>
    <div class="d-flex flex-row flex-nowrap justify-content-around py-3">
        <b class="c-letter" v-for="letter in rangeAtoZ()" :key="letter"
         :class="{'c-underscore': filterActive(letter)}"
         @click="$emit('on-filter-value', letter)">{{ letter }}</b>
    </div>
</div>
</template>

<style scoped>
.nav-link {
    text-decoration: none;
}
.c-underscore {
    text-decoration: underline;
}

.c-letter {
    cursor: pointer;
}

/* Icon tool-button variant (icon + small caption), matching the other tools. */
.c-tool-btn {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    line-height: 1.2;
}
.c-tool-btn-label {
    font-size: 0.65rem;
    margin-top: 2px;
}
</style>